const breakpoints = {
    md: '48.0265em',
};

export default breakpoints;
